'use client';

import { useEffect } from 'react';
import {
	publishMarketInfoDisplay,
	useLiveMarketInfoDisplay,
} from 'src/stores/marketLiveState';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';

/**
 * Produces the derived market-info display data for the currently selected
 * market and publishes it into the live-state module. Mount ONCE (in
 * `useAppSetup`) so the derivation runs a single time and every consumer shares
 * it via `useMarketInfoDisplayData`.
 */
export const useSyncCurrentMarketInfoDisplay = () => {
	const selectedMarketId = useVelocityStore((s) => s.selectedMarket.marketId);

	const marketData = useLiveMarketInfoDisplay(selectedMarketId);

	useEffect(() => {
		publishMarketInfoDisplay(marketData);
	}, [marketData]);
};
